import { ListGroup, ListGroupItem } from "react-bootstrap"

import { MODALS } from "@/constants/modals"
import { useStore } from "@/zustand/store"

export default function LectureTasksModal() {
  const modalData = useStore(
    (state) => state.modalsStates[MODALS.lecture.tasks]
  )
  const lecture = modalData?.lecture
  const course = modalData?.course

  if (!modalData) return null

  return (
    <ListGroup>
      {lecture?.task_ids?.map((taskId) => {
        const task = course?.course_tasks?.find((t) => t.id === Number(taskId))

        return (
          <ListGroupItem
            className="hoverable"
            key={taskId}
            onClick={() => window.open(task?.link)}
          >
            {task?.name}
          </ListGroupItem>
        )
      })}
    </ListGroup>
  )
}
